export const Config = {

    // url: "http://localhost:53350/",
    // url2: "http://localhost:53350/",
    // apiUrl: "http://localhost:53350/api/",
    // loginUrl: "http://localhost:53350/token",
    // appUrl: "http://localhost:4200/#",
    // sso: "http://localhost:53350/sso/index",


    // url:"https://citizen-admin.vnptdaklak.vn/WS/",
    // url2:"https://citizen-admin.vnptdaklak.vn/WS/",
    // apiUrl: "https://citizen-admin.vnptdaklak.vn/WS/api/",
    // loginUrl: "https://citizen-admin.vnptdaklak.vn/WS/token",
    // appUrl:"https://citizen-admin.vnptdaklak.vn/#",
    // sso: "https://citizen-admin.vnptdaklak.vn/WS/sso/index",

    url:"https://citizen-api.daklak.gov.vn/",
    url2:"https://citizen-api.daklak.gov.vn/",
    apiUrl: "https://citizen-api.daklak.gov.vn/api/",
    loginUrl: "https://citizen-api.daklak.gov.vn/token",
    appUrl:"https://citizen-admin.daklak.gov.vn/#",
    sso: "https://citizen-api.daklak.gov.vn/sso/index",


    // url:"https://dieuhanhioc.daklak.gov.vn/WS/",
    // url2:"https://dieuhanhioc.daklak.gov.vn/WS/",
    // apiUrl: "https://dieuhanhioc.daklak.gov.vn/WS/api/",
    // loginUrl: "https://dieuhanhioc.daklak.gov.vn/WS/token",
    // appUrl:"https://dieuhanhioc.daklak.gov.vn/#",
    // sso: "https://dieuhanhioc.daklak.gov.vn/WS/sso/index",
    // sso_logout: "https://xacthuc.daklak.gov.vn/oidc/logout?post_logout_redirect_uri=https://dieuhanhioc.daklak.gov.vn/WS/sso/index"

    // url:"http://ioc.daklak.gov.vn/dieuhanh/WS/",
    // url2:"http://ioc.daklak.gov.vn/dieuhanh/WS/",
    // apiUrl: "http://ioc.daklak.gov.vn/dieuhanh/WS/api/",
    // loginUrl: "http://ioc.daklak.gov.vn/dieuhanh/WS/token",
    // appUrl:"http://ioc.daklak.gov.vn/dieuhanh/#",
    // sso: "http://ioc.daklak.gov.vn/dieuhanh/WS/sso/index",
    // sso_logout: "https://xacthuc.daklak.gov.vn/oidc/logout?post_logout_redirect_uri=http://ioc.daklak.gov.vn/dieuhanh/WS/sso/index"

}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/config/config.ts